module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a0531beb3feee882ee9f052ae34d71bb.png";